
import { defineComponent, onMounted } from 'vue';
import {
    AppFormRow,
    AppInput,
    AppCard,
    AppSelect,
    AppButton,
    AppFileUpload,
    AppImageHolder,
    AppDateTimePicker
} from '@/components';
import { useLiveopsContentEdit } from '@/modules/liveops/item/model/edit-content';
import { LiveopsOptions } from '@/modules/liveops/item/types';

export default defineComponent({
    name: 'LiveopsContentEdition',
    components: {
        AppFormRow,
        AppInput,
        AppSelect,
        AppCard,
        AppButton,
        AppFileUpload,
        AppImageHolder,
        AppDateTimePicker
    },
    setup() {
        const { model, v$, fetch, actions } = useLiveopsContentEdit();

        onMounted(async () => {
            await fetch();
        });

        return { v$, model, actions, LiveopsOptions };
    }
});
